import React from 'react';
import { Navigate } from 'react-router-dom';
import { RoutingStep } from '../../../../../../../../../../models/Routes';
import ListingInformation from '../../../Seller/subrouters/ListingDetailSeller/subrouters/ListingInformation/pages/ListingInformationPage';
import BuyerProfileCard from '../../components/BuyerProfileCard';
import { messagingRoutes, MessageBuyerWrapper } from '../../../../../Messaging';

export default [
  {
    path: 'listing-information',
    element: ListingInformation,
    labelId: 'listing-information',
    stepName: 'listing-information',
  },
  {
    path: 'profile',
    element: BuyerProfileCard,
    labelId: 'profile',
    stepName: 'profile',
  },
  {
    path: 'messaging',
    routes: messagingRoutes,
    element: MessageBuyerWrapper,
  },
  { index: true, element: <Navigate to="listing-information" replace /> },
] as Array<RoutingStep>;
